import I18n from "i18n-js";
import { Layout } from "features/creator/tutorial/top/stages/Layout";
import { Title } from "../Title";

const Step = (props: {
  back: () => void;
  next: () => void;
  close: () => void;
}) => {
  const { next, close } = props;

  return (
    <Layout next={next} close={close}>
      <Title activeStep={7} />

      <div className="flex-col-el items-start justify-center w-[312px]">
        <p className="text-body text-textcolor-black text-[22px] whitespace-pre">
          {I18n.locale === "ja"
            ? "チュートリアルアプリが\nひらけましたね！"
            : "チュートリアルアプリが\n開けましたね！"}
        </p>
      </div>
    </Layout>
  );
};

export default Step;
